import homePage from "../pages/homePage";
import achievementsPage from "../pages/achievementsPage";
import contactPage from "../pages/contactPage";
import aboutPage from "../pages/aboutPage";
import toolsPage from "../pages/toolsPage";
import TheatorPage from "../pages/TheatorPage";
import _404 from "../pages/_404.vue";

// can't export default array because it's not primitive
export default [
  {
    path: "/",
    component: homePage,
    IsMainPath: false,
    progress: 10,
    bg: "linear-gradient(#67B26F, #4ca2cd)",
    redirect: "/home",
    CubeTransformation: {
      xDegree: 0,
      yDegree: 15,
    },
  },
  {
    path: "/home",
    component: homePage,
    IsMainPath: true,
    progress: 10,
    bg: "linear-gradient(#67B26F, #4ca2cd)",
    CubeTransformation: {
      xDegree: 0,
      yDegree: 15,
    },
  },
  {
    path: "/achievements",
    component: achievementsPage,
    IsMainPath: true,
    progress: 30,
    bg: "linear-gradient(#1d4350, #a43931)",
    CubeTransformation: {
      xDegree: 0,
      yDegree: 107,
    },
  },
  {
    path: "/tools",
    component: toolsPage,
    IsMainPath: true,
    progress: 45,
    bg: "linear-gradient(#000428, #004e92)",
    CubeTransformation: {
      xDegree: 90,
      yDegree: 0,
    },
  },
  {
    path: "/about",
    component: aboutPage,
    IsMainPath: true,
    progress: 70,
    bg: "linear-gradient(#4b6cb7, #182848)",
    CubeTransformation: {
      xDegree: -90,
      yDegree: 0,
    },
  },
  {
    path: "/contact",
    component: contactPage,
    IsMainPath: true,
    progress: 100,
    bg: "linear-gradient(#232526, #414345)",
    CubeTransformation: {
      xDegree: 0,
      yDegree: -73,
    },
  },

  {
    path: "/theater/:pageName",
    component: TheatorPage,
    IsMainPath: false,
    bg: "linear-gradient(#232526, #414345)",
  },
  {
    path: "*",
    component: _404,
    IsMainPath: false,
    bg: "linear-gradient(#232526, #414345)",
  },
];

